import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  const getChangeIcon = (change: string) => {
    if (change === 'up') return <i className="ri-arrow-up-s-fill text-primary-500 text-sm"></i>;
    if (change === 'new') return <span className="text-xs text-accent-500 font-bold whitespace-nowrap">NEW</span>;
    return <i className="ri-arrow-down-s-fill text-foreground-400 text-sm"></i>;
  };

  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热播榜单
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时更新 · 全网热播剧集排行
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-4 py-3.5 border-b border-background-200/60 last:border-0 hover:bg-background-100 transition-colors rounded-lg group"
            >
              <div className="w-8 h-8 flex items-center justify-center shrink-0">
                {item.rank <= 3 ? (
                  <span className={`text-lg font-bold ${
                    item.rank === 1 ? 'text-accent-500' :
                    item.rank === 2 ? 'text-secondary-500' :
                    'text-primary-400'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-medium text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                {item.tag}
              </span>

              <div className="flex items-center gap-1.5 shrink-0">
                <span className="text-sm font-bold text-accent-500">{item.hot}</span>
                {getChangeIcon(item.change)}
              </div>

              <a
                href="#ranking"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors shrink-0 cursor-pointer no-underline"
              >
                <i className="ri-play-fill text-sm ml-0.5"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}